import type { Handler } from './handler';
import type { ApiFetchPerfilOficialSectionsPort } from './ports/api-fetch-perfil-oficial-sections.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchPerfilOficialSectionsHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchPerfilOficialSections: resolveAdapter(
      'apiFetchPerfilOficialSections',
    ),
  },
) => {
  const [sections, fetchError] = await tryCatch(
    ports?.apiFetchPerfilOficialSections.handle(params.slug),
  );

  if (fetchError) {
    console.error(
      '[fetchPerfilOficialSectionsHandler] Erro ao buscar dados da API:',
      fetchError,
    );

    return { sections: null };
  }

  return { sections };
};

type Params = { slug: string };

type Ports = {
  apiFetchPerfilOficialSections: ApiFetchPerfilOficialSectionsPort;
};

type Result = Promise<{ sections: HomeSectionData | null }>;
